import { SEGMENT_SOURCES_MAP } from 'utils/constants/trackingSources';

export const initAnalytics = async ({ segmentKey }) => {
  if (!segmentKey) {
    console.error('[Segment] No segmentKey provided');
    return;
  }

  if (!window.analytics) {
    console.error('[Segment] No Segment Snippet loaded');
    return;
  }

  if (window.analytics.load) {
    if (process.env.NODE_ENV !== 'production') {
      console.log(`[Segment] Loading with key: ${segmentKey}`);
    }
    window.analytics.load(segmentKey);
  }
};

export const identifyToSegment = async ({ user }) => {
  if (!window.analytics || !window.analytics.identify) {
    if (process.env.NODE_ENV === 'production') {
      console.error('[Segment] No Segment Snippet loaded');
    }
    return;
  }

  console.log(`[Segment] Identify user:`, user);
  window.analytics.identify(user.uuid, {
    phone: user.phone,
    carrier: user.carrier,
    driver: user.driver
  });
};

export const setSegmentPage = async () => {
  if (!window.analytics || !window.analytics.page) {
    if (process.env.NODE_ENV === 'production') {
      console.error('[Segment] No Segment Snippet loaded');
    }
    return;
  }

  window.analytics.page();
};

export const sendEventToSegment = async (event, params = {}) => {
  if (!process.env.REACT_APP_SEGMENT) return;
  if (!window.analytics || !window.analytics.track) {
    if (process.env.NODE_ENV === 'production') {
      console.warn(`[Segment] Not sending event ${event}`, params);
    }
    return;
  }
  try {
    window.analytics.track(event, params);
  } catch (e) {
    console.error('Error while sending event to segment: ', e);
  }
};

export const getSource = (source, fallbackSource) => {
  if (SEGMENT_SOURCES_MAP.hasOwnProperty(source)) {
    return SEGMENT_SOURCES_MAP[source];
  }

  return fallbackSource;
};
